module.exports = {
  XXXLARGE: 1675,
  XXLARGE: 1420,
  XLARGE: 1192,
  LARGE: 992,
  BREAKPOINT_896: 896,
  BREAKPOINT_812: 812,
  MEDIUM: 768,
  BREAKPOINT_736: 736,
  BREAKPOINT_667: 667,
  SMALL: 640,
  BREAKPOINT_500: 500,
  XSMALL: 415,
  XSMALL_MINUS_1: 414,
  BREAKPOINT_375: 375,
  BREAKPOINT_360: 360,
  XXSMALL: 321,
  MIN: 0,
};
